import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';
import { CTA } from "../../../general/Button";
import { useNavigate } from "react-router-dom";
import TinyModal from "../../../general/TinyModal";

type AgeModalProps = {
    show: boolean;
    onHide: () => void;
};

const AgeRestrictionModal = ({
    show,
    onHide,
}: AgeModalProps) => {

    const renderFooter = () => (
        <>
            <CTA secondary buddies
                 onClick={() => navigate(-1)}
            >
                <span>Go back</span>
            </CTA>
            <CTA buddies
                 onClick={onHide}>
                <span>Continue</span>
            </CTA>
        </>
    )

    const navigate = useNavigate();

    return (
        <TinyModal
            show={show}
            onHide={onHide}
            modalID={'age-modal'}
            header="Age-restricted item"
            footer={renderFooter()}
        >
            <>
                <p>Your order contains an age-restricted item - or items. Please have official photo ID ready, or remove the item(s) from your basket.</p>
            </>
        </TinyModal>
    );
};

export default AgeRestrictionModal;
